import firebase from "firebase/compat/app";
import "firebase/compat/database";
import "firebase/compat/auth";
import "firebase/compat/storage";

const config = {
  apiKey: "AIzaSyCrnHZygccNENrJ-iNbAsQ6DO7xHeE7-w4",
  authDomain: "mona-species-class.firebaseapp.com",
  projectId: "mona-species-class",
  storageBucket: "mona-species-class.appspot.com",
  messagingSenderId: "832582495646",
  appId: "1:832582495646:web:eec73c09bf7def1d57ba8f",
  measurementId: "G-HX929YD1Y7"
};

firebase.initializeApp(config);

export const database = firebase.database();
export const storage = firebase.storage();
export const provider = new firebase.auth.GoogleAuthProvider();
export const auth = new firebase.auth();

export default firebase;
